enum BopisCaseQuantity {
    US = 'bopisCaseQty-us',
    CA = 'bopisCaseQty-ca',
}

export { BopisCaseQuantity };
